export const PLATFORM_ADMIN = "platform admin"
export const ENABLE = "Enable";
export const DISABLE = "Disable";
export const EDIT = "Edit";
export const CORE= "Core";
export const ALTERNATE= "Alternative";
export const ACTIVE = "Active";
export const INACTIVE = "Inactive";
export const EXPIRED = "Expired";
export const UPDATE_CRITICAL_PATH = "Update Critical Path";
export const UPDATE_GEN_AI = "Update Gen AI";
export const UPDATE_TESTAI_EXECUTION_AGENT = "Update TestAI Execution Agent";
export const EDIT_AGENT_KEY = "Edit Agent Key";
export const GEN_AI = "GenAi";
export const EXECUTION_AGENT = 'ExecutionAgent';
export const HIDDEN = 'Hidden';
export const VISIBLE = 'Visible';

export const GEN_AI_ACTION = {
    DISABLE: "Disable Gen AI",
    ENABLE: "Enable Gen AI"
}
export const CRITICAL_PATH = {
    CORE: "Change to Core Critical path",
    ALTERNATE: "Change to Alternative Critical path"
}

export const PROJECT_BACKUP = "Project Backup";

export const DEFAULT_PROJECT_SETTINGS = "Default Project Settings";

export const TESTAI_EXECUTION_AGENT = {
    ENABLE: "Enable TestAI Execution Agent",
    DISABLE: "Disable TestAI Execution Agent", 
    EDIT: "Edit Agent Key"
}
export const DOWNLOAD_REPORT = 'Download Gen AI Usage Report';
export const DELETE_GENAI_TESTCASES = 'Delete Gen AI Testcases';
export const FILTER = {
    PACKAGE_ID: "packageId",
    GEN_AI_STATUS: "genAiStatus",
    CRITICAL_PATH_TYPE: "criticalPathType",
    PROJECT_STATUS: "projectStatus"
}

export const GENAI_GENERATED_TEST_CASES_REPORT = "GenAI Generated Test Cases Report";
export const QUALITY_REPORT = "Download Gen AI Quality Feedback Report";
export const GEN_AI_FLAG = [ENABLE , DISABLE];
export const CRITICAL_PATH_LIST = [CORE, ALTERNATE];
export const GET_USERS_REPORT_URL = "user/user-report-download";
export const GET_PROJECT_REPORT_URL = "platform/project-report-download";
export const GENERATE_GENAI_REPORT_URL = "generate-gen-ai-report";
export const AUTONOMOUS_TESTING_PATH = "autonomous-testing";
export const PROJECT_STATUS_LIST = [ACTIVE, INACTIVE, EXPIRED];

export const REPORT_WILL_BE_DOWNLOADED_SHORTLY =
  "Report will be Downloaded shortly";
export const GENERATING_TESTCASE_REPORT =
  "Generating the testcase report. This may take some time.";
export const GENERATED_TESTCASES_REPORT_DOWNLOADED =
  "File Gen AI Generated TestCases Report has been successfully exported and downloaded to your device";

export const GENERATING_GENAI_REPORT =
  "Generating the GenAI Usage & Quality report. This may take some time.";
export const GENAI_REPORT_DOWNLOADED =
  "File Gen AI Usage & Quality Report has been successfully exported and downloaded to your device";
export const GENAI_REPORT_REPORT_READY_TO_DOWNLOAD =
  "File Gen AI Usage & Quality Report is Ready for downloading";

export const TESTCASE_REPORT_ALLOWED_WIDTH = {
  L1: {
    ALLOWED_WIDTH_PERCENTAGE: 0.75,
    LENGTH_PER_CHARACTER: 10,
  },
  L2: {
    ALLOWED_WIDTH_PERCENTAGE: 0.65,
    LENGTH_PER_CHARACTER: 11,
  },
  L3: {
    ALLOWED_WIDTH_PERCENTAGE: 0.75,
    LENGTH_PER_CHARACTER: 10,
  },
  L4: {
    ALLOWED_WIDTH_PERCENTAGE: 0.75,
    LENGTH_PER_CHARACTER: 10,
  },
  userStory: {
    ALLOWED_WIDTH_PERCENTAGE: 0.75,
    LENGTH_PER_CHARACTER: 10,
  },
};

export const PROJECT_FEATURE_CHOICES = {
  AGENTIC_VIEW: "agenticView",
  WEB_SEARCH: "webSearch",
};

export const UPDATE_AGENTIC_VIEW = "Update Agentic View";

export const AGENTIC_VIEW_ACTION = {
  ENABLE: "Enable Agentic View",
  DISABLE: "Disable Agentic View",
};

export const GENERATED_TESTCASES_REPORT_IN_PROGRESS =
  "Test case report generation for this project is underway. Please wait until the process completes.";

export const DEFAULT_PROJECT_SETTINGS_UPDATED = "Default Project Settings are successfully updated";

export const DEFAULT_PROJECT_SETTINGS_ERROR = "Error updating default project settings";
